module.exports = "/fonts/fontawesome-webfont.svg?acf3dcb7ff752b5296ca23ba2c7c2606";